import React from 'react';
import { Reveal } from './MotionPrimitives';
import journeyImg from '../journy.png';

export default function JourneySplit() {
  return (
    <section id="platform" className="section-pad bg-black">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <span className="pill-light">Our Journey</span>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Built for India&apos;s{' '}
            <span className="grad-text">growing retailers</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-mute">
            Shops were juggling separate tools for online orders, counter billing, stock, and
            delivery. We built one system so a kirana chain, electronics dealer, or FMCG distributor
            can grow without adding more chaos.
          </p>
          <p className="mt-4 text-base leading-relaxed text-mute">
            Today merchants run branded apps, multi-branch stock, Free Cash wallets, rider fleets,
            and courier partners, with AI helpers for buying, expiry, and new store plans.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative z-10">
            <div className="pointer-events-none absolute -inset-2 -z-10 rounded-[1.75rem] bg-accent/10 blur-xl" />
            <img
              src={journeyImg}
              alt="Zuntly journey"
              width={1661}
              height={947}
              decoding="async"
              className="img-glow relative z-10 h-auto w-full object-contain"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
